import { of, switchMap, map, catchError, from, concatMap, delay, endWith, concat } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  appendCharacter,
  completeTypingMessage,
  loadSession,
  populateMessages,
  receiveMessage,
  sendMessage,
  sendMessageFailure,
  setLoading
} from './conversations.actions';
import { ConversationsService } from 'src/app/services/conversations.service';
@Injectable()
export class ConversationsEffects {
  constructor(
    private actions$: Actions,
    private conversationsService: ConversationsService,
    private store: Store<AppState>
  ) {}

  // Create typing effect
  typingEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(receiveMessage),
      switchMap(action => {
        const fullContent = action.response.response;
        const typingSpeed = 4; //ms per character

        return from(fullContent.split('')).pipe(
          concatMap(char => {
            return of(char).pipe(delay(typingSpeed));
          }),
          map(character => appendCharacter({ character })),
          endWith(completeTypingMessage())
        );
      })
    )
  );

  sendMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendMessage),
      switchMap(({ model_id, collection_id, mult_collection_id, session_id, message, activeFilters }) => {
        return concat(
          of(setLoading({ loading: true })),
          this.conversationsService
            .sendMessage(model_id, collection_id, session_id, message, activeFilters, mult_collection_id)
            .pipe(
              map(response => {
                return receiveMessage({ response });
              }),
              catchError(error => of(sendMessageFailure({ error }))),
              endWith(setLoading({ loading: false }))
            )
        );
      })
    )
  );
  loadSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSession),
      switchMap(({ session_id }) =>
        this.conversationsService.loadSession(session_id).pipe(
          map(response => {
            return populateMessages({
              session_id: session_id,
              collection_id: response.collection_id,
              messages: response.history,
              selected_collections_id: response.selected_collections_id
            });
          }),
          catchError(error => of(sendMessageFailure({ error })))
        )
      )
    )
  );
}
